<template>
  <div class="base-responsive-nav">
    <button
      class="hamburger-btn"
      :aria-expanded="String(menuOpen)"
      title="Toggle navigation"
      aria-label="Toggle navigation"
      @click="toggleMenu"
    >
      <svg class="hamburger-icon" width="24" height="18" viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg">
        <rect class="bar bar-1" :class="{ open: menuOpen }" x="0" y="0" width="24" height="2" rx="1" />
        <rect class="bar bar-2" :class="{ open: menuOpen }" x="0" y="8" width="24" height="2" rx="1" />
        <rect class="bar bar-3" :class="{ open: menuOpen }" x="0" y="16" width="24" height="2" rx="1" />
      </svg>
    </button>

    <div v-if="menuOpen" class="mobile-backdrop" :style="{ top: navbarHeight + 'px' }" @click="menuOpen = false" />

    <div
      v-if="menuOpen"
      class="mobile-menu"
      :style="{ top: navbarHeight + 'px', maxHeight: `calc(100dvh - ${navbarHeight}px)`, height: items.length >= 7 ? `calc(100dvh - ${navbarHeight}px)` : undefined }"
    >
      <template v-for="item in items" :key="item.to || item.label">
        <router-link
          v-if="item.to"
          class="mobile-link"
          :to="item.to"
          :target="item.target || undefined"
          @click="menuOpen = false"
        >
          {{ item.label }}
          <span v-if="item.badge" class="nav-badge">{{ item.badge }}</span>
        </router-link>
        <button
          v-else
          class="mobile-link mobile-action"
          :title="item.label"
          :aria-label="item.label"
          @click="item.handler?.(); menuOpen = false"
        >
          {{ item.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseResponsiveNav',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { menuOpen: false, navbarHeight: 70 }
  },
  watch: {
    '$route'() {
      this.menuOpen = false
    },
    menuOpen(open) {
      document.body.style.overflow = open ? 'hidden' : ''
    }
  },
  mounted() {
    this._outsideClick = (e) => {
      if (this.menuOpen && !this.$el.contains(e.target)) {
        this.menuOpen = false
      }
    }
    this._escapeKey = (e) => {
      if (e.key === 'Escape' && this.menuOpen) {
        this.menuOpen = false
      }
    }
    document.addEventListener('click', this._outsideClick)
    document.addEventListener('keydown', this._escapeKey)

    this._navbar = this.$el.closest('.visitorNavbar')
    this.measureNavbar()
    this._resize = () => this.measureNavbar()
    window.addEventListener('resize', this._resize)
  },
  beforeUnmount() {
    document.removeEventListener('click', this._outsideClick)
    document.removeEventListener('keydown', this._escapeKey)
    window.removeEventListener('resize', this._resize)
    document.body.style.overflow = ''
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      if (this.menuOpen) this.measureNavbar()
    },
    measureNavbar() {
      if (this._navbar) this.navbarHeight = this._navbar.offsetHeight
    }
  }
}
</script>

<style scoped>
.base-responsive-nav {
  flex: 1 1 0;
  min-width: 0;
  align-self: stretch;
}

.hamburger-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: var(--nav-edge, 30px);
  top: 50%;
  transform: translateY(-50%);
  touch-action: manipulation;
}

.hamburger-icon {
  display: block;
  fill: var(--color-header-text);
}

.bar {
  transform-box: fill-box;
  transform-origin: center;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.bar-1.open {
  transform: translateY(8px) rotate(45deg);
}

.bar-2.open {
  opacity: 0;
  transform: scaleX(0);
}

.bar-3.open {
  transform: translateY(-8px) rotate(-45deg);
}

.mobile-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--modal-backdrop);
  z-index: 99;
}

.mobile-menu {
  position: fixed;
  left: 0;
  right: 0;
  overflow-y: auto;
  z-index: 100;
  display: flex;
  flex-direction: column;
  background-color: var(--color-header);
}

.mobile-link {
  text-decoration: none;
  font-family: var(--font-decorative, 'Prata', serif);
  color: var(--color-header-text);
  font-size: var(--font-sm);
  padding: 15px 20px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: center;
  border-bottom: 1px solid color-mix(in srgb, var(--color-header-text) 15%, transparent);
  transition: background-color 0.15s;
}

.mobile-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.mobile-action {
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
}

.nav-badge {
  display: inline-block;
  background-color: orange;
  color: var(--color-text);
  font-size: 11px;
  font-family: Arial, sans-serif;
  padding: 1px 5px;
  border-radius: var(--radius-lg);
  margin-left: 4px;
  vertical-align: middle;
}
</style>
